<!DOCTYPE HTML>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <title>This website is temporarily unavailable</title>
    <meta name="description" content="This website is temporarily unavailable">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <link rel="icon" type="image/svg+xml"
        href="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 26'%3E%3Cstyle%3E .wrench %7B fill: %233f3d56; %7D @media (prefers-color-scheme: dark) %7B .wrench %7B fill: %23091133!important; %7D %7D %3C/style%3E%3Cpath d='M14.76 18.4l4.82 4.82a2.66 2.66 0 103.76-3.77l-4.82-4.81zM10.5 8.5L7 5 6 2 2 0 0 2l2 4 3 1 3.5 3.5 2-2z' fill='%2303c39d'/%3E%3Cpath d='M25.7 4.3L22 8l-3.2-.8L18 4 21.7.3a6.16 6.16 0 00-6.24 1.51 4.64 4.64 0 00-1 5.47L2.88 18.88a3 3 0 004.24 4.24l11.6-11.6a4.64 4.64 0 005.47-1A6.16 6.16 0 0025.7 4.3zM5 22a1 1 0 111-1 1 1 0 01-1 1z' class='wrench'/%3E%3C/svg%3E">
    <link rel="icon" type="image/png"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEHUlEQVRoQ+2aT3LbNhTGvweq2Ua9gXKCytskougTVFlY9S7S2F3HOUHiG6T7dOTsEnljn0C0lXYb5wRxThBp15kIfBlQpExKJAiQopxFsfB4xiDw/fD+AHgwIW6TUVM05ISIbuR3cYr94e3qbzX+4rr958ToAfAANFdTMW5I4NK/Hr/WTU/hH2PxoPaqM+GsThDv6aHHFIwAtHIEzkmy5/97fqMHyBKf/KIGENc9eEFMbzTCjMSr70lM336i5MrnjboEeYn94ayKR3U7f4wAHmxDfAjgXL89A9FzI1GMoXSPzoz6ZnTyOgcDBim3yWvGKx8PQJiMWk4j+GIkivlSuscq4Kxb5POTbYoPLaB+2FhBLsSvZdzI7RxcEOj3KgGb9W2chSysYO9GntdrsnzwLT+88Myfji+szRpbwMoKJdyoyH2IcFqU79fhvMcHbTjCW1pANYtYEELsfX8y1Obn5IRFAAxcXU/HaiMzako8OzRh4PMdgF0szIQQ+6YQRQBK9dV0nNKSRxKLj3btWfqjyajpOEEP4B4oN+Disa0gup2+2j8e5sYBi33/43tfZ4I18WHXfGozGGMIr9M/YyB3vymKgyzxeoDEUvzyz6gdyMAHZa6gEYTn9l8z45VmhWfMeOMQ+5Pp+VUqhiKfTx32lh3SMaAzXxUIgx04Y2r2mcl3iG4CsNr9706qUW8C3hkFTjx6EYRciL31Y3g58UbJCCR5zwpADZsLwfxOusepQ1qd4pX7XE3HbWuATIjdi18d+koBpCDAFzteeRB46E/Pw1NxaYB4996lz4eCmf7yP344iaOkGsBarNXs83MCBuuHvq0BVBWvNjIwWozwgp/csecM9oXjnPj++41Cw1YAKotP+LQyqjo7hcYN5Kz4Um+WcnN7bVu8rZxKFrhv8ZWy0M8gvjTAzyK+FEAd4p3rvwcQ6MqnR8NaY6A28YRlrUgVzywhjIO4dvF3W6sVhBHAzsSXgCgE2Ll4SwgtwL2Jt4DIBbh38YYQmQB1iNfe5opypyY7bQB43mGLZfAp6xJdNM8yE95dNrL6F9yr86fIgdgAKKgiaxmKxMcfl4Ug4HTROUq9mW0AdDt9Tqj8TI7oAf/NEDw40dV1TMVXhZAL8Sh5C0wBRO6zeuxIVst0JXJb8ZUg1l6JtBZQhSN/Og5LJVFpT8VGqpUVXxZi3Y2yAFTZ/LdoghlAF8x8SwQFknoSrSq+FATzM+kerx5DNrPQ8v1W95YVnbv02cYkYyX7GAU2Yy6laCWfuLL3AX0hdk7gk7guYytU178QYm31l2k7p0WPEuoxOnYnMPgyrzqwNZDlS5EqWnUTY34lBINF58+N94PCw1wYwN5hK6uksTXRWQNNRs1GY9FeLBq3uv/bMAKoVWjFwf8HqLiAlT//AX1gp5vcm11zAAAAAElFTkSuQmCC" />

    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            /* background-color: #f9f9f9; */
            color: #535368;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
            flex-direction: column;
            text-align: center;
        }

        .artwork {
            height: auto;
            max-height: 50vh;
            max-width: 80vw;
            margin-bottom: 4rem;
        }

        h1 {
            font-size: 2.5rem;
            font-weight: 700;
            margin-bottom: 1rem;
            color: #2f2e41 !important;
        }

        p {
            line-height: 1.6;
            font-size: 1.4rem;
        }

        @media only screen and (max-width: 500px) {
            html {
                font-size: 75%;
            }
        }

        @media (prefers-color-scheme: dark) {
            body {
                background-color: #535368;
                color: #cddcdd;
            }

            h1 {
                color: #f9f9f9;
            }
        }
    </style>
</head>

<body>
    <svg class="artwork" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1120 700" width="1120" height="700">
        <circle cx="292.61" cy="213" r="213" fill="#f2f2f2" />
        <path fill="#2f2e41" d="M0 51.14c0 77.5 48.62 140.21 108.7 140.21" />
        <path fill="#03c39d"
            d="M108.7 191.35c0-78.37 54.26-141.78 121.3-141.78M39.38 58.17c0 73.61 31 133.18 69.32 133.18" />
        <path fill="#2f2e41" d="M108.7 191.35c0-100.14 62.71-181.17 140.2-181.17" />
        <path fill="#a8a8a8"
            d="M85.83 192.34s15.42-.48 20.06-3.78 23.72-7.26 24.87-1.96 23.17 26.4 5.76 26.53-40.44-2.7-45.07-5.53-5.62-15.26-5.62-15.26z" />
        <path
            d="M136.83 211.28c-17.4.15-40.44-2.7-45.07-5.53-3.53-2.15-4.94-9.87-5.41-13.43l-.52.02s.98 12.43 5.62 15.26 27.67 5.67 45.07 5.53c5.03-.04 6.76-1.83 6.67-4.47-.7 1.6-2.62 2.6-6.36 2.62z"
            opacity=".2" />
        <ellipse cx="198.61" cy="424.5" fill="#3f3d56" rx="187" ry="25.44" />
        <ellipse cx="198.61" cy="424.5" opacity=".1" rx="157" ry="21.36" />
        <ellipse cx="836.61" cy="660.5" fill="#3f3d56" rx="283" ry="38.5" />
        <ellipse cx="310.61" cy="645.5" fill="#3f3d56" rx="170" ry="23.13" />
        <path fill="none" stroke="#2f2e41" stroke-miterlimit="10" stroke-width="2"
            d="M462.6 626c90 23 263-30 282-90M309.6 259s130-36 138 80-107 149-17 172M184.01 537.28s39.07-10.82 41.48 24.05-32.16 44.78-5.11 51.7" />
        <path fill="#2f2e41"
            d="M778.7 563.24l-7.87 50.3s-38.78 20.6-11.52 21.2 155.74 0 155.74 0 24.84 0-14.55-21.81l-7.87-52.72z" />
        <path
            d="M753.83 634.2c6.2-5.51 17-11.25 17-11.25l7.87-50.3 113.93.1 7.87 49.59c9.19 5.09 14.88 8.99 18.2 11.98 5.07-1.16 10.6-5.45-18.2-21.4l-7.87-52.71-113.93 3.03-7.87 50.3s-32.6 17.31-17 20.66z"
            opacity=".1" />
        <rect width="513.25" height="357.52" x="578.43" y="212.69" fill="#2f2e41" rx="18.05" />
        <path fill="#3f3d56" d="M595.7 231.78h478.71v267.84H595.7z" />
        <circle cx="835.06" cy="223.29" r="3.03" fill="#f2f2f2" />
        <path fill="#2f2e41"
            d="M1091.69 520.82v31.34a18.04 18.04 0 01-18.05 18.05H596.48a18.04 18.04 0 01-18.05-18.05v-31.34zM968.98 667.47v6.06H642.97v-4.85l.45-1.21 8.03-21.82h310.86l6.67 21.82zM1094.44 661.53c-.6 2.54-2.84 5.22-7.9 7.75-18.18 9.1-55.15-2.42-55.15-2.42s-28.48-4.85-28.48-17.57a22.72 22.72 0 012.5-1.49c7.64-4.04 32.98-14.02 77.92.42a18.74 18.74 0 018.54 5.6c1.82 2.13 3.25 4.84 2.57 7.71z" />
        <path
            d="M1094.44 661.53c-22.25 8.53-42.09 9.17-62.44-4.97-10.27-7.13-19.6-8.9-26.6-8.76 7.65-4.04 33-14.02 77.93.42a18.74 18.74 0 018.54 5.6c1.82 2.13 3.25 4.84 2.57 7.71z"
            opacity=".1" />
        <ellipse cx="1066.54" cy="654.13" fill="#f2f2f2" rx="7.88" ry="2.42" />
        <circle cx="835.06" cy="545.67" r="11.51" fill="#f2f2f2" />
        <path d="M968.98 667.47v6.06H642.97v-4.85l.45-1.21h325.56z" opacity=".1" />
        <path fill="#2f2e41" d="M108.61 159h208v242h-208z" />
        <path fill="#3f3d56" d="M87.61 135h250v86h-250zM87.61 237h250v86h-250zM87.61 339h250v86h-250z" />
        <path fill="#03c39d" d="M271.61 150h16v16h-16z" opacity=".4" />
        <path fill="#03c39d" d="M294.61 150h16v16h-16z" opacity=".8" />
        <path fill="#03c39d" d="M317.61 150h16v16h-16z" />
        <path fill="#03c39d" d="M271.61 251h16v16h-16z" opacity=".4" />
        <path fill="#03c39d" d="M294.61 251h16v16h-16z" opacity=".8" />
        <path fill="#03c39d" d="M317.61 251h16v16h-16z" />
        <path fill="#03c39d" d="M271.61 352h16v16h-16z" opacity=".4" />
        <path fill="#03c39d" d="M294.61 352h16v16h-16z" opacity=".8" />
        <path fill="#03c39d" d="M317.61 352h16v16h-16z" />
        <circle cx="316.61" cy="538" r="79" fill="#2f2e41" />
        <path fill="#2f2e41" d="M280.61 600h24v43h-24zM328.61 600h24v43h-24z" />
        <ellipse cx="300.61" cy="643.5" fill="#2f2e41" rx="20" ry="7.5" />
        <ellipse cx="348.61" cy="642.5" fill="#2f2e41" rx="20" ry="7.5" />
        <circle cx="318.61" cy="518" r="27" fill="#fff" />
        <circle cx="318.61" cy="518" r="9" fill="#3f3d56" />
        <path fill="#03c39d"
            d="M239.98 464.53c-6.38-28.57 14-57.43 45.54-64.47s62.27 10.4 68.64 38.98-14.51 39.1-46.05 46.14-61.75 7.92-68.13-20.65z" />
        <ellipse cx="417.22" cy="611.34" fill="#2f2e41" rx="39.5" ry="12.4" transform="rotate(-23.17 156.4 637.65)" />
        <ellipse cx="269.22" cy="664.34" fill="#2f2e41" rx="39.5" ry="12.4" transform="rotate(-23.17 8.4 690.65)" />
        <path fill="#fff" d="M362.6 561c0 7.73-19.9 23-42 23s-43-14.27-43-22 20.92-6 43-6 42-2.73 42 5z" />
    </svg>
    <h1>Sorry we're down for maintenance.</h1>
    <p>We'll be back shortly.</p>
    <p>-Team KoinNation</p>
</body>

</html>